// extracted by mini-css-extract-plugin
export var actionButton = "_7m-1";
export var actionButtons = "_7m-2";
export var actions = "_7m-0";
export var aiUnread = "_7m-10";
export var alignCenter = "_7m-h";
export var backWrapper = "_7m-3";
export var cellContainer = "_7m-4";
export var checkboxContainer = "_7m-5";
export var contentContainer = "_7m-6";
export var contentHeader = "_7m-8";
export var conversationsTableWrapper = "_7m-s";
export var draftReplyBadgeContainer = "_7m-m";
export var dropdownItem = "_7m-b";
export var dropdownItemsContainer = "_7m-a";
export var dropdownTitle = "_7m-c";
export var errorIcon = "_7m-7";
export var filter = "_7m-d";
export var gray = "_7m-i";
export var headerActionButtons = "_7m-e";
export var headerCheckboxContainer = "_7m-f";
export var icon = "_7m-j";
export var menuContainer = "_7m-k";
export var noMoreTicketsIcon = "_7m-12";
export var noMoreTicketsSubText = "_7m-13";
export var oneLine = "_7m-l";
export var optionsButton = "_7m-n";
export var plus = "_7m-o";
export var portalButtonsWrapper = "_7m-g";
export var red = "_7m-p";
export var scrolledTop = "_7m-9";
export var search = "_7m-q";
export var selectedConversationsCount = "_7m-r";
export var spinner = "_7m-t";
export var strong = "_7m-u";
export var summaryCell = "_7m-v";
export var tableContainer = "_7m-11";
export var tagContainer = "_7m-w";
export var threeDots = "_7m-x";
export var twoLines = "_7m-y";
export var unread = "_7m-z";